import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

// Services
// import NotificationsListPage from '@/pages/Notifications/List.vue'
import MessengerPage from '@/pages/Messenger/Messenger.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index'

const notifications: RouteConfig = {
  path: '/notifications',
  name: 'notifications',
  meta: {
    pageName: messages.messeger.notification
  },
  component: DashboardLayout,
  redirect: '/notifications/list',
  children: [
    {
      path: 'list',
      name: 'notificationsListPage',
      meta: {
        pageName: messages.messeger.notifications_list
      },
      component: MessengerPage
    }
  ]
}

export default notifications